const reportColumns = [
  {
    title: '报备人',
    dataIndex: 'reporter',
    key: 'reporter',
    width: 60
  },
  {
    title: '部门',
    dataIndex: 'dept',
    key: 'dept',
    ellipsis: true
  },
  {
    title: '业务员',
    dataIndex: 'salesman',
    key: 'salesman',
    width: 60
  },
  {
    title: '公司名称',
    dataIndex: 'customerFullName',
    key: 'customerFullName',
    ellipsis: true
  },
  {
    title: '地址',
    dataIndex: 'address',
    key: 'address',
    ellipsis: true
  },
  {
    title: '行业',
    dataIndex: 'industry',
    key: 'industry',
    sorter: (a, b) => a.servicePhone.localeCompare(b.servicePhone)
  },
  {
    title: '决策人',
    dataIndex: 'contactPerson',
    key: 'contactPerson',
    width: 60

  },
  {
    title: '手机号码',
    dataIndex: 'mobile',
    key: 'mobile'
  },
  {
    title: '职位',
    dataIndex: 'professionalTitle',
    key: 'professionalTitle',
    width: 80
  },
  {
    title: '现有品牌',
    dataIndex: 'brand',
    key: 'brand',
    ellipsis: true
  },
  {
    title: '现有空压机',
    dataIndex: 'infoNote',
    key: 'infoNote',
    ellipsis: true
  },
  {
    title: '竞争对手',
    dataIndex: 'competitor',
    key: 'competitor',
    ellipsis: true
  },
  {
    title: '项目困难',
    dataIndex: 'hard',
    key: 'hard',
    ellipsis: true
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
    ellipsis: true
  },
  {
    title: '创建时间',
    dataIndex: 'createdAt',
    key: 'createdAt',
    ellipsis: true
  },
  {
    title: '最后修改时间',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    ellipsis: true
  }
]

export {
  reportColumns
}
